<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <router-link to="/market"
          >{{ pair.split("_")[0] }}/{{ pair.split("_")[1] }}
          <i class="fad fa-chevron-down"></i
        ></router-link>

        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i>
          </a>
        </div>
        <div class="right">
          <a v-on:click="addFavorites">
            <span class="text-accent" v-if="starmarket[pair]">
              <span class="fad fa-star"></span>
            </span>
            <span class="text-muted" v-else>
              <span class="far fa-star"></span>
            </span>
          </a>
        </div>
      </div>
    </div>

    <div class="container-center lg animated fadeIn">
      <div class="m-t-xl" v-if="getMarket">
        <div v-for="market in getMarket" v-bind:key="market.pair">
          <div v-if="market.pair == pair">
            <div v-if="getTrade.length > 0">
              <!-- last price  -->
              <span class="text-buy lastprice" v-if="getTrade[0].type == 'BUY'">
                {{ ratedigi(getTrade[0].rate) }}
                <i class="m-l-xs fad fa-long-arrow-alt-up"></i>
              </span>

              <span
                class="text-sell lastprice"
                v-if="getTrade[0].type == 'SELL'"
              >
                {{ ratedigi(getTrade[0].rate) }}
                <i class="m-l-xs fad fa-long-arrow-alt-down"></i>
              </span>

              <span class="m-l-md font-bold c-white"
                >{{ $t("avg") }} {{ ratedigi(market.average) }}</span
              >
              <!--  -->

              <!-- percent change -->
              <span
                href="#"
                class="btn btn-muted pull-right c-white font-bold"
                v-if="market.change / 1 == 0"
                >0.00%</span
              >
              <span
                href="#"
                class="btn btn-buy pull-right c-white font-bold"
                v-else-if="market.change / 1 > 0"
                >+{{ market.change }}%</span
              >
              <span
                href="#"
                class="btn btn-sell pull-right c-white font-bold"
                v-else
                >{{ market.change }}%</span
              >
              <!--  -->

              <!-- volume -->
              <div class="row">
                <div class="col-xs-6">
                  {{ $t("Vol") }}
                  <span class="c-white">
                    {{ fixed(market.volume_24hrs / 1) }}
                    {{ pair.split("_")[1] }}
                  </span>
                  <br />
                  {{ $t("Vol") }}
                  <span class="c-white">
                    {{ fixed(market.amount_24hrs / 1) }}
                    {{ pair.split("_")[0] }}
                  </span>
                </div>
                <div class="col-xs-6 text-right">
                  {{ $t("Low") }}
                  <span class="c-white">{{ ratedigi(market.low / 1) }}</span>
                  <br />
                  {{ $t("High") }}
                  <span class="c-white">{{ ratedigi(market.high / 1) }}</span>
                </div>
              </div>
              <!--  -->
            </div>
            <div class="lastprice" v-else>
              <span class="text-muted">
                N/A
                <i class="fad fa-long-arrow-alt-right"></i>
              </span>

              <span href="#" class="btn btn-muted c-white font-bold pull-right"
                >N/A</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- choose type chart -->
    <div class="container-center lg animated fadeIn">
      <div class="row">
        <button
          class="btn btn-xs btn-accent pull-right"
          data-type="candle"
          v-on:click="loadChart('candle')"
        >
          <i class="fad fa-bar-chart-o"></i> Candlestick
        </button>
        <button
          class="btn btn-xs btn-accent m-r-xs pull-right"
          v-on:click="loadChart('line')"
        >
          <i class="fad fa-area-chart"></i> Line
        </button>
        <div id="candleChart">
          <div class="loader-example">
            <div class="loader-bar"></div>
          </div>
        </div>
      </div>
    </div>
    <!--  -->

    <!-- tab -->
    <div class="topmarket">
      <div class="container lg">
        <div class="tophead text-center">
          <div class="col-xs-3 active" v-if="type == 'MARKETS'">
            <p class="pointer">{{ $t("Trades") }}</p>
          </div>
          <div class="col-xs-3" v-else v-on:click="type = 'MARKETS'">
            <p class="pointer">{{ $t("Trades") }}</p>
          </div>
          <div class="col-xs-3 active" v-if="type == 'DEPTHCHART'">
            <p class="pointer">{{ $t("DepthChart") }}</p>
          </div>
          <div
            class="col-xs-3"
            v-else
            v-on:click="
              type = 'DEPTHCHART';
              loadDepthChart();
            "
          >
            <p class="pointer">{{ $t("DepthChart") }}</p>
          </div>
          <div class="col-xs-3 active" v-if="type == 'ORDERBOOK'">
            <p class="pointer">{{ $t("OrderBook") }}</p>
          </div>
          <div class="col-xs-3" v-else v-on:click="type = 'ORDERBOOK'">
            <p class="pointer">{{ $t("OrderBook") }}</p>
          </div>
          <div class="col-xs-3 active" v-if="type == 'INFO'">
            <p class="pointer">{{ $t("Info") }}</p>
          </div>
          <div class="col-xs-3" v-else v-on:click="type = 'INFO'">
            <p class="pointer">{{ $t("Info") }}</p>
          </div>
        </div>
      </div>
    </div>
    <!--  -->

    <div class="container-center lg animated fadeIn">
      <!-- MARKETS -->
      <div class="row container-tab" v-if="type == 'MARKETS'">
        <div class="col-xs-4">
          <small>{{ $t("Time") }}</small>
        </div>
        <div class="col-xs-4 text-center">
          <small>{{ $t("Price") }}</small>
        </div>
        <div class="col-xs-4 text-right">
          <small>{{ $t("Amount") }}</small>
        </div>
        <div class="col-xs-12" v-if="getTrade.length > 0">
          <div
            class="row"
            v-for="b in getTrade.slice(0, 1000)"
            v-bind:key="b._id"
          >
            <div class="col-xs-4">{{ time(b.timestamps) }}</div>
            <div class="col-xs-4 text-center">
              <span class="text-buy" v-if="b.type == 'BUY'">
                {{ ratedigi(b.rate) }}
              </span>
              <span class="text-sell" v-else>{{ ratedigi(b.rate) }}</span>
            </div>
            <div class="col-xs-4 text-right c-white">
              {{ volumedigi(b.volume) }}
            </div>
          </div>
        </div>
      </div>
      <!--  -->

      <!-- DEPTHCHART -->
      <div class="row container-tab" v-if="type == 'DEPTHCHART'">
        <div id="depthChart">
          <div class="loader-example">
            <div class="loader-bar"></div>
          </div>
        </div>
      </div>
      <!--  -->

      <!-- ORDERBOOK -->
      <div class="row container-tab" v-if="type == 'ORDERBOOK'">
        <div class="col-xs-6 orders">
          <div class="row">
            <div class="col-xs-6">
              <small>{{ $t("Total") }}({{ pair.split("_")[1] }})</small>
            </div>
            <div class="col-xs-6 text-right">
              <small>{{ $t("Price") }}({{ pair.split("_")[0] }})</small>
            </div>
            <div class="col-xs-12" v-if="getDepth.bids">
              <div
                class="row"
                v-for="b in getDepth.bids.slice(-30).reverse()"
                v-bind:key="b[0]"
              >
                <div class="col-xs-6 c-white">{{ volumedigi(b[1]) }}</div>
                <div class="col-xs-6 text-buy text-right">
                  {{ ratedigi(b[0]) }}
                  <div
                    class="amount-bar-buy buy-bar"
                    v-bind:style="
                      'width: ' + ((b[1] * b[0]) / 10000) * 185 + '%;'
                    "
                  ></div>
                </div>
              </div>
              <div v-if="30 - getDepth.bids.length > 0">
                <div v-for="i in 30 - getDepth.bids.length" v-bind:key="i">
                  <div class="col-xs-6 c-white">--</div>
                  <div class="col-xs-6 text-right text-buy">--</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-6 orders">
          <div class="row">
            <div class="col-xs-6">
              <small>{{ $t("Price") }}({{ pair.split("_")[0] }})</small>
            </div>
            <div class="col-xs-6 text-right">
              <small>{{ $t("Total") }}({{ pair.split("_")[1] }})</small>
            </div>
            <div class="col-xs-12" v-if="getDepth.asks">
              <div
                class="row"
                v-for="b in getDepth.asks.slice(0, 30)"
                v-bind:key="b[0]"
              >
                <div class="col-xs-6 text-sell">
                  {{ ratedigi(b[0]) }}
                  <div
                    class="amount-bar-sell sell-bar"
                    v-bind:style="
                      'width: ' + ((b[1] * b[0]) / 10000) * 185 + '%;'
                    "
                  ></div>
                </div>
                <div class="col-xs-6 text-right c-white">
                  {{ volumedigi(b[1]) }}
                </div>
              </div>
              <div v-if="30 - getDepth.asks.length > 0">
                <div v-for="i in 30 - getDepth.asks.length" v-bind:key="i">
                  <div class="col-xs-6 text-sell">--</div>
                  <div class="col-xs-6 text-right c-white">--</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  -->

      <!-- INFO -->
      <div class="row container-tab" v-if="type == 'INFO'">
        <div v-if="getPairing">
          <div v-for="pairing in getPairing" v-bind:key="pairing.pair">
            <div v-if="pairing.pair == pair">
              <div class="col-xs-12 text-center m-t-md m-b-md">
                <img
                  class="coin"
                  :src="require(`@/assets/tokens/${pairing.secondary}.png`)"
                />
              </div>
              <div class="col-xs-6 text-right">
                <p>{{ $t("BaseAsset") }}</p>
                <p>{{ $t("QuoteAsset") }}</p>
                <p>{{ $t("MinimumBuyVolume") }}</p>
                <p>{{ $t("MinimumSellVolume") }}</p>
                <p>{{ $t("CommissionBuy") }}</p>
                <p>{{ $t("CommissionSell") }}</p>
                <p>{{ $t("Status") }}</p>
              </div>
              <div class="col-xs-6">
                <p class="c-white">{{ pairing.name }}</p>
                <p class="c-white">{{ pairing.primary }}</p>
                <p class="c-white">
                  {{ pairing.primary_min }} {{ pairing.primary }}
                </p>
                <p class="c-white">
                  {{ pairing.secondary_min }} {{ pairing.secondary }}
                </p>
                <p class="c-white">{{ pairing.primary_fee }}%</p>
                <p class="c-white">{{ pairing.secondary_fee }}%</p>
                <p class="c-white">{{ pairing.status }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  -->
    </div>
  </div>
</template>

<script>
//HighChart Config
import Highcharts from "highcharts";
import stockInit from "highcharts/modules/stock";
import More from "highcharts/highcharts-more";

More(Highcharts);
stockInit(Highcharts);

import { mapGetters, mapActions } from "vuex";
import func from "@/widgets/func.js";
import moment from "moment";
import exchange from "@/api/exchange.js";

export default {
  data() {
    return {
      pricechart: null,
      market: null,
      starmarket: JSON.parse(localStorage.getItem("StarMarket")),
      pair: this.$route.params.pair,
      amount: null,
      volume: null,
      type: "MARKETS",
      rate: null,
      depthchart: null,
    };
  },
  computed: {
    ...mapGetters([
      "getPair",
      "getPairing",
      "getDepth",
      "getTrade",
      "getMarket",
    ]),
  },
  methods: {
    ...mapActions([
      "setPair",
      "fetchDepth",
      "fetchTrade",
      "setTrade",
      "setDepth",
    ]),
    time(t) {
      return moment(t).format("HH:mm:ss");
    },
    fixed(a) {
      return func.fixed(a);
    },
    ratedigi(a) {
      if (a) {
        return a.toFixed(this.getPairing[this.pair].rate_digi);
      }
    },
    volumedigi(a) {
      if (a) {
        return a.toFixed(this.getPairing[this.pair].volume_digi);
      }
    },
    addFavorites() {
      var oldItems = JSON.parse(localStorage.getItem("StarMarket"));

      oldItems[this.pair] = !oldItems[this.pair];

      this.starmarket = oldItems;
      localStorage.setItem("StarMarket", JSON.stringify(oldItems));
    },
    loadDepthChart() {
      exchange.depth(this.pair).then(
        async function (res) {
          this.setDepth(res.data);
          var sorted = await this.splitDepthData(res.data);

          this.depthchart = await new Highcharts.chart("depthChart", {
            chart: {
              type: "area",
              reflow: true,
              zoomType: "xy",
              backgroundColor: null,
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: false,
            },
            title: {
              text: null,
            },
            tooltip: {
              headerFormat:
                '<span style="font-size=10px;">' +
                sorted.secondary +
                "/" +
                sorted.primary +
                ": {point.key}</span><br/>",
              valueDecimals: 2,
            },

            plotOptions: {
              area: {
                fillOpacity: 0.3,
                lineWidth: 1,
                step: "center",
                marker: {
                  enabled: false,
                },
              },
            },
            annotationsOptions: { enabledButtons: false },
            series: [
              {
                name: `Bids(${sorted.secondary})`,
                data: sorted.bids,
                color: "#71a610",
                animation: false,
              },
              {
                name: `Asks(${sorted.secondary})`,
                data: sorted.asks,
                color: "#ff2a68",
                animation: false,
              },
            ],
            yAxis: [
              {
                lineWidth: 0,
                gridLineWidth: 0,
                title: null,
                tickWidth: 1,
                tickLength: 5,
                tickPosition: "inside",
                labels: {
                  align: "left",
                  x: 8,
                },
              },
              {
                opposite: true,
                linkedTo: 0,
                lineWidth: 0,
                gridLineWidth: 0,
                title: null,
                tickWidth: 1,
                tickLength: 5,
                tickPosition: "inside",
                labels: {
                  align: "right",
                  x: -8,
                },
              },
            ],
          });
        }.bind(this)
      );
    },
    splitDepthData(data) {
      // var bids = [];
      // for (const b of data.bids) {
      //   if (b[0] > this.getTrade[0].rate * 0.95) {
      //     bids.push(b);
      //   }
      // }

      // var asks = [];
      // for (const a of data.asks) {
      //   if (a[0] < this.getTrade[0].rate * 1.05) {
      //     asks.push(a);
      //   }
      // }
      return {
        primary: data.pair.split("_")[0],
        secondary: data.pair.split("_")[1],
        bids: data.bids,
        asks: data.asks,
        last: data.last,
      };
    },
    loadChart(chart_type) {
      exchange.chart(this.pair).then(
        async function (res) {
          var sorted = await this.splitPriceData(res.data);

          this.pricechart = await new Highcharts.StockChart("candleChart", {
            chart: {
              zoomType: false,
              pinchType: "x",
              backgroundColor: "transparent",
              alignTicks: false,
              reflow: true,
              // margin: [5, 5, 5, 5]
            },
            credits: {
              enabled: false,
            },
            navigator: {
              enabled: false,
            },
            scrollbar: {
              enabled: false,
            },
            title: {
              text: null,
            },
            rangeSelector: {
              inputEnabled: false,
              selected: 0,
              buttons: [
                {
                  type: "day",
                  count: 7,
                  text: "7D",
                },
                {
                  type: "month",
                  count: 1,
                  text: "M",
                },
                {
                  type: "month",
                  count: 3,
                  text: "3M",
                },
                {
                  type: "month",
                  count: 6,
                  text: "6M",
                },
                {
                  type: "all",
                  // count: 1,
                  text: "ALL",
                },
              ],
              buttonTheme: {
                fill: "#505053",
                stroke: "#000000",
                style: {
                  color: "#CCC",
                },
                states: {
                  hover: {
                    fill: "#f6a821",
                    stroke: "#000000",
                    style: {
                      color: "white",
                    },
                  },
                  select: {
                    fill: "#f6a821",
                    stroke: "#000000",
                    style: {
                      color: "white",
                    },
                  },
                },
              },
              inputStyle: {
                color: "white",
              },
            },
            xAxis: {
              lineColor: "#FFF",
              lineWidth: 0,
              tickWidth: 0,
              tickColor: "#FFF",
              labels: {
                y: 10,
              },
            },
            yAxis: [
              {
                plotLines: [
                  {
                    zIndex: 4,
                    value: sorted.last,
                    color: "rgba(246,168,33, 1)",
                    width: 0.7,
                    id: "rate",
                    dashStyle: "LongDash",
                    label: {
                      text: "<code>" + sorted.last + "</code>",
                      useHTML: true,
                      align: "left",
                      x: 0,
                      y: 4,
                    },
                  },
                ],
                min: null,
                title: {
                  text:
                    this.pair.split("_")[1] + " / " + this.pair.split("_")[0],
                  offset: 8,
                },
                height: 270,
                offset: 0,
                opposite: false,
                labels: {
                  format: "{value}",
                  x: 35,
                },
                lineWidth: 1,
                lineColor: "#282D33",
                gridLineWidth: 1,
                gridLineColor: "#282D33",
              },
              {
                endOnTick: false,
                title: {
                  text: "Volume",
                  offset: 8,
                },
                labels: {
                  enabled: false,
                },
                opposite: false,
                top: 285,
                height: 80,
                offset: 0,
                tickWidth: 0,
                gridLineWidth: 0,
                lineWidth: 1,
                lineColor: "#282D33",
              },
            ],
            tooltip: {
              shared: true,
              split: false,
              backgroundColor: "#1d1f24",
              style: {
                color: "#F0F0F0",
              },
              formatter: null,
              crosshairs: [
                {
                  color: "#5D5D5D",
                  dashStyle: "dash",
                  width: 1,
                },
                {
                  color: "#5D5D5D",
                  dashStyle: "dash",
                  width: 1,
                },
              ],
            },
            plotOptions: {
              candlestick: {
                color: "#ff2a68",
                lineColor: "#ff2a68",
                upColor: "#71A610",
                upLineColor: "#71A610",
              },
            },

            annotations: [],
            annotationsOptions: { stroke: "white" },
            series: [
              {
                type: "column",
                name: "Volume",
                color: "#3E4048",
                data: sorted.volume,
                yAxis: 1,
              },
              {
                type: "areasplinerange",
                name: "Low - High",
                data: sorted.areadata,
                color: "#777",
                animation: false,
                visible: chart_type == "line",
              },
              {
                type: "spline",
                name: "Average",
                data: sorted.line,
                color: "#f6a821",
                visible: chart_type == "line",
                yAxis: 0,
                animation: false,
              },
              {
                type: "candlestick",
                name: "Price",
                data: sorted.ohlc,
                yAxis: 0,
                visible: chart_type == "candle",
                animation: false,
              },
            ],
          });
        }.bind(this)
      );

      this.$socket.off("chart." + this.getPair);
      this.$socket.on(
        "chart." + this.pair,
        function (data) {
          var sorted = this.splitPriceData(data);
          if (this.pricechart) {
            this.pricechart.series[0].setData(sorted.volume);
            this.pricechart.series[1].setData(sorted.areadata);
            this.pricechart.series[2].setData(sorted.line);
            this.pricechart.series[3].setData(sorted.ohlc);
            this.pricechart.yAxis[0].options.plotLines[0].value = sorted.last;
            this.pricechart.yAxis[0].options.plotLines[0].label.text =
              "<code>" + sorted.last + "</code>";
            this.pricechart.yAxis[0].update();
          }
        }.bind(this)
      );
    },
    splitPriceData(data) {
      var ohlc = [];
      var areadata = [];
      var line = [];
      var volume = [];
      var last = data[data.length - 1][4];

      // split the data set into ohlc and volume
      var dataLength = data.length,
        i = 0;

      for (i; i < dataLength; i += 1) {
        ohlc.push([
          data[i][0], // the date
          this.ratedigi(data[i][1]) / 1, // open
          this.ratedigi(data[i][2]) / 1, // high
          this.ratedigi(data[i][3]) / 1, // low
          this.ratedigi(data[i][4]) / 1, // close
        ]);

        areadata.push([
          data[i][0], // the date
          this.ratedigi(data[i][3]) / 1, // low
          this.ratedigi(data[i][2]) / 1, // high
        ]);

        line.push([
          data[i][0], // the date
          this.ratedigi(data[i][6]) / 1, // average
        ]);

        volume.push([
          data[i][0], // the date
          this.volumedigi(data[i][5]) / 1, // the volume
        ]);
      }

      return {
        last: last,
        volume: volume,
        ohlc: ohlc,
        areadata: areadata,
        line: line,
      };
    },
  },
  created() {
    this.loadChart("candle");

    this.$socket.off("depth." + this.getPair);
    this.$socket.on(
      "depth." + this.pair,
      function (data) {
        this.setDepth(data);
      }.bind(this)
    );

    this.$socket.off("trade." + this.getPair);
    this.$socket.on(
      "trade." + this.pair,
      function (data) {
        this.setTrade(data);
      }.bind(this)
    );

    if (this.pair) {
      this.fetchDepth(this.pair);
      this.fetchTrade(this.pair);
      this.setPair(this.pair);
    }
  },
};
</script>

<style scoped>
#depthChart {
  height: 240px;
  padding: 0px;
  margin: 0px;
}
.container-tab {
  padding-bottom: 80px;
}
.container-center {
  margin-top: 0px;
  padding: 10px;
}

.active p {
  padding-bottom: 7px;
  color: #f6a821;
  border-bottom-color: #f6a821;
  border-bottom: solid;
  margin: 0 0 5px;
}
.percent {
  position: relative;
  float: left;
  width: 25%;
  padding-left: 3px;
  padding-right: 3px;
  text-align: center;
}
.btnp {
  width: 100%;
  display: inline-block;
  font-size: 13px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  background-image: none;
  border: 1px solid #949ba2;
  border-radius: 0px;
  color: #949ba2;
}
.btnp:hover {
  border: 1px solid #f6a821;
  color: #f6a821;
}
.orders .col-xs-6 {
  padding-right: 10px;
  padding-left: 10px;
}
.lastprice {
  font-size: 24px;
  font-weight: bold;
  margin-right: -10px;
  margin-top: 5px;
  margin-bottom: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.text-sell:hover,
.text-buy:hover {
  color: #fff;
}
.markettrades {
  padding: 5px 15px;
  font-size: 15px;
  font-weight: bold;
  color: white;
  background-color: #494b54;
}
.toptab {
  padding-top: 10px;
  width: 100%;
  height: 33px;
  background-color: #1d1f24;
}
.coin {
  width: 32px;
}

.loader-example {
  padding: 60px 0;
  height: 200px;
}

.amount-bar-sell.sell-bar {
  background: rgba(255, 42, 104, 0.1);
  max-width: 185%;
}
.amount-bar-buy.buy-bar {
  background: rgba(113, 166, 16, 0.1);
  max-width: 185%;
}
.amount-bar-sell {
  position: absolute;
  width: 0;
  bottom: 0;
  top: 0;
  left: 5px;
  z-index: -1;
}
.amount-bar-buy {
  position: absolute;
  width: 0;
  bottom: 0;
  right: 0;
  top: 0;
  z-index: -1;
}
.tophead .col-xs-3 {
  font-size: 13px;
  padding-left: 3px;
  padding-right: 3px;
}
.topmarket {
  padding-top: 5px;
  position: static;
  width: 100%;
  height: 33px;
  background-color: #1d1f24;
  z-index: 10;
  margin: 0 auto 0;
}
</style>
